"use client";
import clsx from "clsx";

// TODO: 予約フォームにコンポーネント展開
export function FormItem({
  label,
  description,
  error,
  children,
  styleDisabled,
  bgColor = "white",
}: {
  label: string;
  description?: string;
  error?: string;
  children: React.ReactNode;
  styleDisabled?: boolean;
  bgColor?: "white" | "slightbeige-100" | "slightbeige-112";
}) {
  return (
    <div className="flex flex-col">
      <div
        className={inputTextStyle("w-[105px]", error, !!styleDisabled, bgColor)}
      >
        <div className="font-roboto text-skogecha-80 text-[10px] leading-none">
          {label}
        </div>
        <div
          className={clsx("h-full font-normal", { "pt-[4px]": styleDisabled })}
        >
          {children}
        </div>
      </div>
      {(error || description) && (
        <div
          className={clsx(
            "mt-[8px] px-[12px] text-xs leading-relaxed wrap-break-word",
            error && "text-salert",
          )}
        >
          {error || description}
        </div>
      )}
    </div>
  );
}
function inputTextStyle(
  custom: string,
  isError: unknown,
  styleDisabled: boolean,
  bgColor: "white" | "slightbeige-100" | "slightbeige-112",
) {
  return clsx(
    "h-[56px] w-full rounded-t px-[12px] pb-[14px] pt-[10px] [&_input]:bg-transparent [&_textarea]:bg-transparent [&_select]:bg-transparent",
    custom,
    {
      "border-b border-b-skogecha": !isError,
      "border-b-2 border-b-salert": isError,
      "bg-white": !styleDisabled && bgColor === "white",
      "bg-slightbeige-100": !styleDisabled && bgColor === "slightbeige-100",
      "bg-slightbeige-112": !styleDisabled && bgColor === "slightbeige-112",
      "bg-[#F2F2F1]": styleDisabled,
    },
  );
}
